import { useEffect, useState } from 'react';
import { Building2 } from 'lucide-react';

interface AccountFaviconProps {
  domain?: string | null;
  className?: string;
}

function normalizeDomain(domain?: string | null): string | null {
  if (!domain) return null;

  try {
    const url = domain.includes('://') ? domain : `https://${domain}`;
    return new URL(url).hostname;
  } catch {
    return domain.replace(/^https?:\/\//, '').split('/')[0] || null;
  }
}

export default function AccountFavicon({
  domain,
  className = 'h-4 w-4',
}: AccountFaviconProps) {
  const faviconDomain = normalizeDomain(domain);
  const [faviconError, setFaviconError] = useState(false);

  useEffect(() => {
    setFaviconError(false);
  }, [faviconDomain]);

  if (!faviconDomain || faviconError) {
    return <Building2 className={`${className} flex-shrink-0 opacity-60`} />;
  }

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(faviconDomain)}&sz=128`}
      alt=""
      className={`${className} flex-shrink-0 rounded-[3px] object-contain`}
      onError={() => setFaviconError(true)}
    />
  );
}
